// import React from 'react';

// export default function Userlevel() {
//     return(
//         <div>
//             <h1>React User level page</h1>
//         </div>
//     )
// }


import React, { useEffect, useState } from "react";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import SettingSidebar from "../../components/Setttingsidebar";
import { Link, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import "../../App.css";
import { ApiUrl } from '../../Constants/Weburl'
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import CustomPagination from "../../components/Custompagination";
import CustomContainer from '../../components/Customsettingscontain';
import CustomTable from '../../components/CustomTable';
import CustomButton from "../../components/CustomButton";
import CustomInput from '../../components/Custominput';
import { createUserLevelCoin, getLevelCoins, deleteLevelCoins, updateUserLevelCoin } from "../../services/reactapis";
import DeleteModal from "../../components/DeleteModal";
import Layout from "../../components/Layout";
import SettingsPageShell from "../../components/SettingsMenu";


// export default function Hashtags() {

//     const [allhashtag, setAllhashtag] = useState([]);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [pageSize, setPageSize] = useState(10);
//     const [totalPages, setTotalPages] = useState(1);
//     const [searchText, setSearchText] = useState("");
//     const [inputValue, setInputValue] = useState(""); // For input field display

//     //add hashtag state
//     const [hashtags, setHashtags] = useState([]);
//     const [newHashtag, setNewHashtag] = useState("");
//     const [editingId, setEditingId] = useState(null);
//     const [editingText, setEditingText] = useState("");

//     //add modal 
//     const [showModal, setShowModal] = useState(false);

//     //save model
//     const [showEditModal, setShowEditModal] = useState(false);
//     const [editId, setEditId] = useState(null);
//     const [editTag, setEditTag] = useState("");

//     const navigate = useNavigate();
//     const location = useLocation();

//     // Read search from URL on component mount
//     useEffect(() => {
//         const params = new URLSearchParams(location.search);
//         const searchParam = params.get('search');
//         if (searchParam) {
//             console.log("Search term from URL:", searchParam);
//             setSearchText(searchParam); // For API filtering
//             // Do NOT set inputValue - keep it empty
//         }
//     }, []);

//     // Update search when URL changes
//     useEffect(() => {
//         const params = new URLSearchParams(location.search);
//         const searchParam = params.get('search');
//         if (searchParam && searchParam !== searchText) {
//             console.log("Search term updated from URL:", searchParam);
//             setSearchText(searchParam);
//             setCurrentPage(1);
//             // Do NOT set inputValue - keep it empty
//         }
//     }, [location.search]);

//     //all hashtag get api
//     const fetchHashtags = async (page = 1) => {
//         try {
//             const res = await axios.get(`${ApiUrl}api/search`, {
//                 params: {
//                     page,
//                     limit: pageSize,
//                     search: searchText
//                 }
//             });

//             console.log("hashtag search", res.data)

//             setAllhashtag(res.data.data);
//             setCurrentPage(page);
//             setTotalPages(res.data.totalPages);

//         } catch (e) {
//             console.log("fetchHashtags error", e);
//         }
//     };

//     useEffect(() => {
//         fetchHashtags(1);
//     }, [pageSize, searchText]);

//     //add hashtag api 
//     const addHashtag = async () => {

//         let tag = newHashtag.trim();

//         if (!tag) return;

//         if (!tag.startsWith("#")) {
//             tag = "#" + tag;
//         }

//         if (tag.length > 11) {
//             alert("Hashtag must be 10 letters or less");
//             return;
//         }

//         try {

//             const res = await axios.post(
//                 `${ApiUrl}api/hashtags`,
//                 { name: tag }
//             );

//             setAllhashtag(prev => [res.data.data, ...prev]);

//             setNewHashtag("");

//             setShowModal(false);

//         } catch (err) {
//             console.log(err);
//         }
//     };

//     //edit hashtag api
//     const saveEdit = async () => {

//         let tag = editTag.trim();

//         if (!tag.startsWith("#")) {
//             tag = "#" + tag;
//         }

//         if (tag.length > 11) {
//             alert("Hashtag must be 10 letters or less");
//             return;
//         }

//         try {

//             const res = await axios.put(
//                 `${ApiUrl}api/edithashtags/${editId}`,
//                 { name: tag }
//             );

//             setAllhashtag(prev =>
//                 prev.map(item =>
//                     item.id === editId ? res.data.data : item
//                 )
//             );

//             setShowEditModal(false);

//         } catch (err) {
//             console.log(err);
//         }
//     };

//     //delete hashtag api
//     const deleteHashtag = async (id) => {
//         if (!window.confirm("Delete this hashtag?")) return;

//         try {
//             const res = await axios.delete(
//                 `${ApiUrl}api/deletehashtags/${id}`
//             );

//             console.log("res deleteHashtag", res.data);

//             setAllhashtag(prev => prev.filter(h => h.id !== id));

//         } catch (err) {
//             console.error("Delete error", err);
//             alert("Failed to delete hashtag");
//         }
//     };

//     const handleSearchChange = (e) => {
//         const value = e.target.value;
//         setInputValue(value);
//         setSearchText(value);
//         setCurrentPage(1);

//         const params = new URLSearchParams(location.search);
//         if (value) {
//             params.set('search', value);
//         } else {
//             params.delete('search');
//         }
//         navigate(`${location.pathname}?${params.toString()}`, { replace: true });
//     };

//     return (
//         <div className="layout">
//             <Sidebar />
//             <main className="content">
//                 <Topbar />

//                  <div className="settings-container">
//                     <SettingSidebar />

//                 <CustomContainer className="rr-wrapperhashtag" fluid="false">
//                     <div className="rr-top-headerhashtag">
//                         <h3>Hashtags</h3>
//                         {searchText && (
//                             <span style={{ marginLeft: '15px', fontSize: '14px', color: '#666' }}>
//                                 Showing results for: <strong>"{searchText}"</strong>
//                             </span>
//                         )}
//                         <CustomButton className="rr-add-btnhashtag" 
//                             variant='#e2f0ef'
//                             onClick={() => setShowModal(true)}
//                         >
//                             Add Hashtag
//                         </CustomButton>
//                     </div>

//                     <div className="rr-card">
//                         <div className="rr-controls">
//                             <div className="rr-left">
//                                 Show
//                                 <select
//                                     className="rr-select"
//                                     value={pageSize}
//                                     onChange={(e) => setPageSize(Number(e.target.value))}>
//                                     <option>5</option>
//                                     <option>10</option>
//                                     <option>25</option>
//                                     <option>50</option>
//                                 </select>
//                                 entries
//                             </div>

//                             <div className="rr-right">
//                                 <span>Search:</span>
//                                 <CustomInput
//                                     className="rr-search"
//                                     type="text"
//                                     value={inputValue} // Use inputValue for display
//                                     onChange={handleSearchChange}
//                                     placeholder="Search hashtag"
//                                 />
//                             </div>
//                         </div>

//                         <CustomTable
//                             className="rr1-table"
//                             headers={[
//                                 { label: "Hashtags", className: 'rr-actions1' },
//                                 { label: "Post Count", className: 'rr-actions1' },
//                                 { label: "Action", className: 'rr-actions' },
//                             ]}
//                         >
//                             {allhashtag.map((item, idx) => (
//                                 <tr className="rr-actionshastag" key={idx} >
//                                     <td className="rr-actions1">
//                                         <Link
//                                             to={`/Hashtagdetails/${item.tag.replace("#", "")}`}
//                                             target="_blank"
//                                             className="hashtagahref"
//                                         >
//                                             <h5 className="h3hashtag">
//                                                 {item.tag}
//                                             </h5>
//                                         </Link>
//                                     </td>
//                                     <td className="rr-actions2">{item.posts}</td>
//                                     <td className="rr-actions">
//                                         <CustomButton
//                                             className="rr-icon-btn green"
//                                             onClick={() => {
//                                                 setEditId(item.id);
//                                                 setEditTag(item.tag);
//                                                 setShowEditModal(true);
//                                             }}
//                                         >
//                                             <i className="bi bi-pencil"></i>
//                                         </CustomButton>

//                                         <CustomButton
//                                             className="rr-icon-btn red"
//                                             onClick={() => deleteHashtag(item.id, item.tag)}
//                                         >
//                                             <i className="bi bi-trash"></i>
//                                         </CustomButton>
//                                     </td>
//                                 </tr>
//                             ))}
//                         </CustomTable>

//                         <div className="rr-footer">
//                             <span>
//                                 Showing 1 to {allhashtag.length} of {allhashtag.length} entries
//                             </span>

//                             <CustomPagination
//                                 currentPage={currentPage}
//                                 totalPages={totalPages}
//                                 onPageChange={(page) => fetchHashtags(page)}
//                                 className="rr-pagination"
//                                 pageClassName="rr-page"
//                                 activeClassName="active"
//                                 ellipsisClassName="rr-page"
//                             />
//                         </div>
//                     </div>
//                 </CustomContainer>
//                  </div>
//             </main>

//             {/* Add Hashtag Modal */}
//             <Modal
//                 show={showModal}
//                 onHide={() => setShowModal(false)}
//                 centered
//             >
//                 <Modal.Header closeButton>
//                     <Modal.Title>Add Hashtag</Modal.Title>
//                 </Modal.Header>

//                 <Modal.Body>
//                     <Form.Control
//                         type="text"
//                         placeholder="Enter hashtag"
//                         value={newHashtag}
//                         onChange={(e) => setNewHashtag(e.target.value)}
//                     />
//                 </Modal.Body>

//                 <Modal.Footer>
//                     <Button
//                         variant="secondary"
//                         onClick={() => setShowModal(false)}
//                     >
//                         Cancel
//                     </Button>
//                     <Button
//                         variant="primary"
//                         onClick={addHashtag}
//                     >
//                         Add
//                     </Button>
//                 </Modal.Footer>
//             </Modal>

//             {/* Edit Hashtag Modal */}
//             <Modal
//                 show={showEditModal}
//                 onHide={() => setShowEditModal(false)}
//                 centered
//             >
//                 <Modal.Header closeButton>
//                     <Modal.Title>Edit Hashtag</Modal.Title>
//                 </Modal.Header>

//                 <Modal.Body>
//                     <Form.Control
//                         value={editTag}
//                         onChange={(e) => setEditTag(e.target.value)}
//                     />
//                 </Modal.Body>

//                 <Modal.Footer>
//                     <Button
//                         variant="secondary"
//                         onClick={() => setShowEditModal(false)}
//                     >
//                         Cancel
//                     </Button>
//                     <Button
//                         variant="primary"
//                         onClick={saveEdit}
//                     >
//                         Save
//                     </Button>
//                 </Modal.Footer>
//             </Modal>
//         </div>
//     );
// }


export default function Userlevel() {

  const [showModal, setShowModal] = useState(false);

  const [coins, setCoins] = useState('');

  const [level, setLevel] = useState('');

  const [levelCoins, setLevelCoins] = useState([]);

  const [editlevelId, setEditLevelsId] = useState(null);


  //delete modal 
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [deleteTag, setDeleteTag] = useState("");

  const reportheaders = [
    "Title",
    "Actions"
  ];


  useEffect(() => {
    fetchLevelCoins();
  }, []);

  //submit
  const handleSubmit = async () => {
    try {
      const token = localStorage.getItem("adminToken");

      // const response = await createUserLevelCoin(token, {
      //     level: level,
      //     coins: coins,
      // });

      let response;

      if (editlevelId) {
        // EDIT
        response = await updateUserLevelCoin(token, editlevelId, {
          level: level,
          coins: coins,
        });
      } else {
        // ADD
        response = await createUserLevelCoin(token, {
          level: level,
          coins: coins,
        });
      }

      console.log("CREATE RESPONSE:", response);

      if (response?.success) {
        alert("Level coins added successfully");

        setLevel("");
        setCoins("");
        setEditLevelsId(null);
        setShowModal(false);

        // GET latest list
        fetchLevelCoins();
      }

    } catch (error) {
      console.log("SAVE ERROR:", error);
    }
  };


  //fetch all level and coins collections
  const fetchLevelCoins = async () => {
    try {
      const token = localStorage.getItem("adminToken");

      const response = await getLevelCoins(token);

      console.log("LEVEL COINS:", response);

      if (response?.success) {
        setLevelCoins(response.data);
      }

    } catch (error) {
      console.log("GET ERROR:", error);
    }
  };

  const handleEditUserLevel = (item) => {
    setEditLevelsId(item.id);

    setLevel(item.level);
    setCoins(item.coins);

    setShowModal(true);
  };

  //delete level coins
  const handledeleteuserlevels = async (id) => {
    try {
      const token = localStorage.getItem("adminToken");

      const response = await deleteLevelCoins(token, id);

      console.log("DELETE RESPONSE:", response);

      if (response?.success) {

        // UI-la immediately remove pannum
        setLevelCoins((prev) =>
          prev.filter((item) => item.id !== id)
        );
        setShowDeleteModal(false);
        setDeleteId(null);

        // alert("Coin package deleted successfully");
      }

    } catch (error) {
      console.error(
        "Delete coin package error:",
        error?.response?.data || error
      );

      alert(
        error?.response?.data?.message ||
        "Failed to delete coin package"
      );
    }
  };


const closeLevelModal = () => {
  setShowModal(false);
  setEditLevelsId(null);
  setLevel("");
  setCoins("");
};


  return (
      <>
       <Layout>
         <SettingsPageShell
          title="User Levels"
          headerRight={
            <button
              className="rr-add-btn"
              onClick={() => {
                setEditLevelsId(null);
                setLevel("");
                setCoins("");
                setShowModal(true);
              }}
            >
              Add User Levels
            </button>
          }
        >
       

            <div className="rr-card">
              <div className="rr-controls">
                <div className="rr-left">
                  Show
                  <select className="rr-select">
                    <option>10</option>
                    <option>25</option>
                    <option>50</option>
                  </select>
                  entries
                </div>

                <div className="rr-right">
                  <span>Search:</span>
                  <input className="rr-search" type="text" />
                </div>
              </div>

              <CustomTable
                // headers={reportheaders}
                className="rr-table"
                striped={'false'}
              >
                {/* <thead> */}
                <tr>
                  <th>Levels</th>
                  <th>Coins Collections</th>
                  <th className="rr-action-col">Action</th>
                </tr>
                {/* </thead> */}

                {/* <tbody> */}
                {levelCoins.map((item) => (
                  <tr
                    key={item.id}
                  >
                    <td>{item.level}</td>

                    <td>{item.coins}</td>

                    <td className="rr-actions">
                      <CustomButton
                        reportclassName="rr-icon-btn green"
                        onClick={() => handleEditUserLevel(item)}
                      >
                        <i className="bi bi-pencil"></i>
                      </CustomButton>

                      <CustomButton
                        reportclassName="rr-icon-btn red"
                         onClick={() => {
                        setDeleteId(item.id);
                        setDeleteTag(item.coins);
                        setShowDeleteModal(true);
                      }}
                        // onClick={() => handledeleteuserlevels(item.id)}
                      >
                        <i className="bi bi-trash"></i>
                      </CustomButton>
                    </td>
                  </tr>
                ))}
                {/* </tbody> */}
              </CustomTable>

              <div className="rr-footer">
                <span>
                  Showing 1 to {levelCoins.length} of {levelCoins.length} entries
                </span>

                <div className="rr-pagination">
                  <span className="rr-page-arrow">&lt;</span>
                  <span className="rr-page active">1</span>
                  <span className="rr-page-arrow">&gt;</span>
                </div>
              </div>
            </div>
      
      
        </SettingsPageShell>
    
       

      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        className="hashtag-add-modal"
      >
        <Modal.Header className="hashtag-modal-header">
          <Modal.Title>{editlevelId ? "Edit User Level" : "Add User Level"}</Modal.Title>

          <CustomButton
            type="button"
            className="hashtag-close-btn"
            onClick={closeLevelModal}
          >
            ×
          </CustomButton>
        </Modal.Header>

        <Modal.Body className="hashtag-modal-body">

          {/* Coins */}
          <Form.Group>
            <Form.Label className="profile-pill">Level</Form.Label>
            <Form.Control
              type="text"
              // placeholder="Enter Level"
              value={level}
              onChange={(e) => setLevel(e.target.value)}
            />
          </Form.Group>

          <Form.Group >
            <Form.Label className="profile-pill">Coins Collection</Form.Label>
            <Form.Control
              type="number"
              // placeholder="Enter Coins"
              value={coins}
              onChange={(e) => setCoins(e.target.value)}
            />
          </Form.Group>


        </Modal.Body>

        <Modal.Footer className="hashtag-modal-footer">
          <CustomButton
            className="hashtag-close-footer-btn"
            variant="secondary"
            onClick={closeLevelModal}
          >
            Cancel
          </CustomButton>

          <CustomButton
            variant="primary"
            className="hashtag-save-btn"
            onClick={handleSubmit}
          >
            {editlevelId ? 'UpdateLevels' : "Submit"}
          </CustomButton>
        </Modal.Footer>
      </Modal>


        <DeleteModal
                  show={showDeleteModal}
                  close={() => {
                    setShowDeleteModal(false);
                    setDeleteId(null);
                    setDeleteTag('');
                  }}
                  onDelete={() => handledeleteuserlevels(deleteId)}
                  title="Delete UserLevels"
                  message="Are you sure you want to delete this Levels ?"
                  itemName={`${deleteTag}`}
                />
                 </Layout>
     </>
  );
}


